// extracted by mini-css-extract-plugin
export var addressDisplay = "components-account-panels-__PersonalInformation-module___addressDisplay";
export var addressRow = "components-account-panels-__PersonalInformation-module___addressRow";
export var defaultAddressDisplay = "components-account-panels-__PersonalInformation-module___defaultAddressDisplay";
export var invisible = "components-account-panels-__PersonalInformation-module___invisible";
export var spinner = "components-account-panels-__PersonalInformation-module___spinner";
export var spinnerWrapper = "components-account-panels-__PersonalInformation-module___spinnerWrapper";